import { LocaleService } from "./LocaleService";
import {BTypeService} from "./BTypeService";

export const localeService = new LocaleService();
export const bTypeService = new BTypeService();
